import { useEffect } from "react";
import { geTImportsFilterParams, setImportsFilterParams, TImportsFilterState } from "../store/importsSlice";
import { useTypedDispatch } from "./useTypedDispatch";
import { useTypedSelector } from "./useTypedSelector";

export default function useImports(initImportsFilter?: Partial<TImportsFilterState>) {
  const dispatch = useTypedDispatch();

  // --
  // -- Filter params
  // --
  const importsFilter =  useTypedSelector(geTImportsFilterParams());
  const setFilterParams = (filterState: Partial<TImportsFilterState>) => dispatch(setImportsFilterParams(filterState));  

  useEffect(() => {
    initImportsFilter && setFilterParams(initImportsFilter);
  }, []);

return {
  setFilterParams,
  importsFilter,
 };
};
